import type { InputType } from "@re/shared";

/** 브라우저용 가벼운 분류기 — 서버 scripts/classify_url.sh 와 동일한 우선순위. */
export function classifyTarget(target: string): InputType {
  const t = target.trim();
  if (!t) return "topic";
  if (!/^https?:\/\//i.test(t)) return "topic";
  let url: URL;
  try { url = new URL(t); } catch { return "topic"; }
  const h = url.hostname.toLowerCase();
  if (h.includes("youtube.com") || h === "youtu.be" || h === "m.youtube.com") return "youtube";
  if (h.includes("arxiv.org")) return "arxiv";
  if (h === "github.com" || h.endsWith(".github.com")) return "github";
  if (h === "huggingface.co" || h.endsWith(".huggingface.co")) return "huggingface";
  if (h === "news.ycombinator.com" || h.includes("reddit.com") || h.includes("lobste.rs")) return "community";
  return "blog";
}
